function formatDate(unixTimestamp, dateFormat, timezone) {
	// default to America/New_York if no timezone is provided
	if ( ! timezone || timezone === 'undefined' ) {
		timezone = 'America/New_York';
	}

	const date = new Date(unixTimestamp * 1000); // Convert Unix timestamp to milliseconds

	// Format the date according to the provided format string
	let format = {};

	if (dateFormat === 'month') {
		format = { timeZone: timezone, month: 'long' };
	} else if (dateFormat === 'M') {
		format = { timeZone: timezone, month: 'short' };
	} else if (dateFormat === 'year') {
		format = { timeZone: timezone, year: 'numeric' };
	} else if (dateFormat === 'day') {
		format = { timeZone: timezone, day: 'numeric' };
	} else if ( dateFormat === 'time' ) {
		format = { timeZone: timezone, hour: 'numeric', minute: 'numeric' };
	} else if ( dateFormat === 'timezone' ) {
		format = { timeZone: timezone, hour: 'numeric', minute: 'numeric', timeZoneName: 'short' };
	} else {
		format = { 
			timeZone: timezone,
			year: 'numeric',
			month: 'long',
			day: 'numeric',
		};
	}

	if ( dateFormat === 'timezone' || dateFormat === 'time' ) {
		return date.toLocaleTimeString('en-US', format);
	}

	return date.toLocaleDateString('en-US', format);

}

// function convertTimestampToFormattedDate(timestamp, format, timezone) {
// 	const date = new Date(timestamp * 1000); // Convert Unix timestamp to milliseconds
// 	const options = { timeZone: timezone, hour12: false };
  
// 	const formattedDate = date.toLocaleString('en-US', options)
// 							 .replace(/(\d+)\/(\d+)\/(\d+),/, '$3-$1-$2'); // Reformat date as YYYY-MM-DD
  
// 	let formattedTime = formattedDate.split(',')[1].trim(); // Extract time portion
  
// 	if (format === '24-hour') {
// 	  formattedTime = formattedTime.replace(/(AM|PM)\s/, ''); // Remove AM/PM if using 24-hour format
// 	}
  
// 	return formattedTime;
//   }

export default formatDate;